import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { LedgerEntriesSearch } from '../LedgerEntriesTable/elements/LedgerEntriesSearch/LedgerEntriesSearch'
import { StatementExportMenu } from '../StatementExportMenu'

interface LedgerEntriesToolbarProps {
  ledgerSearchQuery?: string
  onSearchChange: (ledgerSearchQuery?: string) => void
}

export const LedgerEntriesToolbar = ({
  ledgerSearchQuery,
  onSearchChange,
}: LedgerEntriesToolbarProps): ReactElement => (
  <Flex alignItems="center" gap={Spacing.S12} width="100%">
    <Flex.Item flexGrow={1}>
      <LedgerEntriesSearch ledgerSearchQuery={ledgerSearchQuery} onSearchChange={onSearchChange} />
    </Flex.Item>
    <StatementExportMenu />
  </Flex>
)
